import { RootState } from '@/store';

export const selectHomeState = (state: RootState) => state.home;
export const selectDropdownOpen = (state: RootState) => state.home.dropdownOpen;
export const selectLoading = (state: RootState) => state.home.loading;
export const selectCurrentPath = (state: RootState) => state.home.currentPath;
export const selectHomeData = (state: RootState) => state.home.data;
export const selectSearchQuery = (state: RootState) => state.home.searchQuery;
export const selectSearchResults = (state: RootState) => state.home.searchResults;
export const selectSearchLoading = (state: RootState) => state.home.searchLoading;
export const selectAcessos = (state: RootState) => state.home.acessos;
export const selectHomeCount = (state: RootState) => state.home.searchResults?.length ?? 0;
